<template>
    <div>
        <v-select
            :items="items"
            :label="label"
            item-text="name"
            item-value="id"
            multiple
            rounded
            outlined
            dense
            class="filter"
            v-bind="$attrs"
            append-icon="mdi-chevron-down"
            v-on="$listeners"
        >
        </v-select>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
            default: String,
        },
        current: {
            type: Object,
            required: false,
            default: () => {
                return null;
            },
        },
        hiddenItems: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            items: [],
        };
    },
    created() {
        this.loadRoles();
    },
    methods: {
        clear() {
            this.$emit('clear');
        },
        loadRoles() {
            axios.get(route('api.v1.roles.options')).then((response) => {
                // this.items = response.data.data;
                const list = _.clone(response.data.data);
                const filteredList = list.filter((x) => !this.hiddenItems.includes(x.name));
                this.items = _.union(
                    [
                        {
                            name: t('default::label.all'),
                            id: '',
                        },
                    ],
                    filteredList
                );
            });
        },
    },
};
</script>

<style scoped></style>
